import axiosInstance from "api/axios";
import { DashboardPerformance, DashboardStats } from "../types/dashboard.type";

export const dashboardService = {
  // Basic counts (products, users, depots, etc.)
  getStats: async (subCompanyId?: number | null): Promise<DashboardStats> => {
    const response = await axiosInstance.get("/dashboard/stats", {
      params: subCompanyId ? { subCompanyId } : {},
    });
    return response.data;
  },

  // Performance analytics (gain, profit, charges, etc.)
  getPerformance: async (
    dateFrom?: string,
    dateTo?: string,
    subCompanyId?: number | null
  ): Promise<DashboardPerformance> => {
    const response = await axiosInstance.get("/dashboard/performance", {
      params: {
        ...(dateFrom ? { dateFrom } : {}),
        ...(dateTo ? { dateTo } : {}),
        ...(subCompanyId ? { subCompanyId } : {}),
      },
    });
    return response.data;
  },
};
